<template>
  <v-card flat class="text-xs-left">
    <v-card-title dense small class="subheading black--text text-uppercase">
      <strong>ERP Profile</strong>
      <v-spacer />
        <v-btn @click="generate" small color="blue" outline>Generate API / Secret Key</v-btn>&nbsp;
      <v-btn @click="submit" small color="blue" outline>Save</v-btn>&nbsp;
    </v-card-title>
    <hr />
    <v-snackbar v-model="snackbar" color="blue" top>
      <center>Erp Profile Saved</center>
    </v-snackbar>
    <v-card-text>
      <v-form v-model="valid">
        <v-layout row wrap>
          <v-flex xs2 sm2 class="field text-xs-left">
            <strong>Erp</strong>
            <br />
            <v-autocomplete
              attach
              class="style-input mr-2 pt-1"
              v-validate="'required'"
              data-vv-name="erp_type"
              item-text="name"
              item-value="erp_type"
              label
              outline
              single-line
              hide-details
             
              :error-messages="errors.collect('erp_type')"
              v-model="erpProfile.erp_type"
              :items="erps"
            />
          </v-flex>
          <v-flex xs2 sm2 class="field text-xs-left">
            <strong>Integration Type</strong>
            <br />
            <v-autocomplete
              attach
              class="style-input mr-2 pt-1"
              v-validate="'required'"
              data-vv-name="integration_type "
              item-text="name"
              item-value="id"
              label
              outline
              single-line
              hide-details
              :error-messages="errors.collect('integration_type ')"
              v-model="erpProfile.integration_type "
              :items="integrationTypes"
            />
          </v-flex>
          <v-flex xs4>
            <strong>Api Key</strong>
            <br />
            <v-text-field
              class="style-input mr-2 pt-1"
              v-validate="'required'"
              data-vv-name="apiKey"
              type="text"
              outline
              single-line
              :error-messages="errors.collect('apiKey')"
              v-model="erpProfile.apiKey"
              required
            />
          </v-flex>
          <v-flex xs4>
            <strong>Shared Secret</strong>
            <br />
            <v-text-field
              class="style-input mr-2 pt-1"
              v-validate="'required'"
              data-vv-name="sharedSecret"
              type="text"
              outline
              single-line
              :error-messages="errors.collect('sharedSecret')"
              v-model="erpProfile.sharedSecret"
              required
            />
          </v-flex>
          <v-flex xs6 class="field text-xs-left">
            <strong>URL</strong>
            <br />
            <v-text-field
              class="style-input mr-2 pt-1"
              v-validate="'required'"
              data-vv-name="url"
              type="text"
              outline
              single-line
              :error-messages="errors.collect('url')"
              v-model="erpProfile.url"
              required
            />
          </v-flex>
          <v-flex xs2 class="field text-xs-left" v-if="erpProfile.erp_type=='ENV'">
            <strong>Company</strong>
            <br />
            <v-text-field
              class="style-input mr-2 pt-1"
              v-validate="'required'"
              data-vv-name="company_code"
              type="text"
              outline
              single-line
              :error-messages="errors.collect('urcompany_codel')"
              v-model="erpProfile.company_code"
              required
            />
          </v-flex>
           <v-flex xs4 class="field text-xs-left" v-if="erpProfile.integration_type=='D'">
            <strong>Db Type</strong>
            <br />
            <v-autocomplete
              attach
              class="style-input mr-2 pt-1"
              v-validate="'required'"
              data-vv-name="db_type "
              item-text="name"
              item-value="name"
              label
              outline
              single-line
              hide-details
              :error-messages="errors.collect('db_type ')"
              v-model="erpProfile.db_type "
              :items="dbType"
            />
          </v-flex>
          <v-flex xs5>
            <strong>DB String</strong>
            <br />
            <v-textarea
              class="style-input mr-2 pt-1"
              v-validate="'required'"
              data-vv-name="dbString"
              type="text"
              outline
              rows="5"
              :error-messages="errors.collect('dbString')"
              v-model="erpProfile.dbString"
              required
            />
          </v-flex>
          
        </v-layout>
      </v-form>
    </v-card-text>
    <v-card-actions class="justify-end">
      <v-btn @click="submit" small color="blue" outline>Save</v-btn>&nbsp;
    </v-card-actions>
  </v-card>
</template>
<script>
import ErpModel from "@/api/service/ErpService.js";
import CompanyModel from "@/api/service/CompanyService";
import RoleModel from "@/api/service/RolesService";
const uuidv1 = require('uuid/v1');
export default {
  data() {
    return {
      erpProfile: {},
      erps: [],
      loggedCompany: {},
      integrationTypes: [
        { id: "D", name: "Direct" },
        { id: "I", name: "Integration" }
      ],
      dbType: [
        {  name: "Oracle" },
        {  name: "Mysql" },
         {  name: "Postgresql" },
        {  name: "Mssql" }
      ],
      snackbar:false
    };
  },
  created: function() {
    this.getErpProfile();
    this.getErps();
  },
  methods: {
   
      async generate(){
          this.erpProfile.apiKey = uuidv1();
          this.erpProfile.sharedSecret = uuidv1();
          this.$forceUpdate();
      },
    async getErps() {
      this.erps = await ErpModel.findAll({ active: 1 });
    },
    async getErpProfile() {
      let $user = await RoleModel.getRoleForMyId();
      this.loggedCompany = $user[0].companies;
      this.erpProfile = $user[0].companies.erp_profile
        ? JSON.parse($user[0].companies.erp_profile)
        : {};
    },
    submit() {
      var navigate = this.$router;
      if(this.erpProfile.integration_type=='I'){
        delete this.erpProfile.db_type
      }
      if(this.erpProfile.erp_type!='ENV'){
        delete this.erpProfile.company_code
      }
      let $erpProfile = JSON.stringify(this.erpProfile);
      CompanyModel.update({
        id: this.loggedCompany.id,
        erp_profile: $erpProfile
      })
        .then(response => {
          this.snackbar = true;
          setTimeout(() => {
            navigate.replace("/settings");
          }, 2000);
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>